import React from 'react';
import { components } from 'react-select';
export default /*#__PURE__*/React.memo(props => {
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, props.selectProps?.dropDownIcon);
});